import React, { PureComponent } from 'react'
import { Alert, Button } from 'react-bootstrap'

const groups = ['client_admins', 'managers', 'clerks']
const emailRegexp =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

class AddUserComponent extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      groups: '',
      formChanged: false,
      selectedGroups: [],
    }
  }

  changeHandler = ({ target }) => this.setState({ [target.name]: target.value, formChanged: true })

  changeGroupsHandler = ({ target }) => this.setState({ selectedGroup: target.value })

  validForm = () => {
    const { state } = this

    const validationResult =
      state.first_name.trim().length &&
      state.last_name.trim().length &&
      state.email.trim().length &&
      this.isValidEmail(state.email.trim())

    return validationResult
  }

  handleCreateUser = async () => {
    const { props, state } = this
    const user = {
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      group: state.selectedGroup,
      send_welcome_email: true,
    }
    this.setState({ formChanged: false })
    await props.createUser(user)
  }

  validationMessage = (name) => {
    const { errors } = this.props
    if (errors && errors[name] && !this.state.formChanged) {
      return (
        <div>
          {errors[name].map((e, index) => (
            <span key={index} className='help-block'>
              {e}
            </span>
          ))}
        </div>
      )
    } else {
      return null
    }
  }

  isValidEmail = () => emailRegexp.test(this.state.email)

  render() {
    const { state, props } = this
    const { isFetching } = this.props
    return (
      <form className='form-horizontal'>
        <fieldset>
          {props.errorMessage && !state.formChanged && (
            <div>
              <Alert variant='danger'>{props.errorMessage}</Alert>
              {props.errorDetails &&
                props.errorDetails.length > 0 &&
                props.errorDetails.map((e, index) => (
                  <Alert key={index} variant='danger'>
                    {e}
                  </Alert>
                ))}
            </div>
          )}
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='email'>
              Email Address
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-envelope-o' />
                </div>
                <input
                  id='email'
                  name='email'
                  type='email'
                  required
                  placeholder='Email Address'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.email}
                />
              </div>
              {this.validationMessage('email')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='first_name'>
              First Name
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-users' />
                </div>
                <input
                  id='first_name'
                  name='first_name'
                  required
                  placeholder='First Name'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.first_name}
                />
              </div>
              {this.validationMessage('first_name')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='last_name'>
              Last Name
            </label>
            <div className='col-md-4'>
              <div className='input-group'>
                <div className='input-group-addon'>
                  <i className='fa fa-male' />
                </div>
                <input
                  id='last_name'
                  name='last_name'
                  required
                  placeholder='Last Name'
                  className='form-control input-md'
                  disabled={isFetching}
                  onChange={this.changeHandler}
                  value={state.last_name}
                />
              </div>
              {this.validationMessage('last_name')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' htmlFor='groups'>
              Groups
            </label>
            <div className='col-md-4'>
              <div className='input-group' style={{ zIndex: '9999' }}>
                <div className='input-group-addon'>
                  <i className='fa fa-user' />
                </div>
                <select
                  value={state.selectedGroup}
                  name={'groups'}
                  id={'groups'}
                  className='form-control input-md'
                  onChange={this.changeGroupsHandler}
                >
                  <option defaultValue={''} />
                  {groups.map((group, index) => (
                    <option key={index} value={group}>
                      {group}
                    </option>
                  ))}
                </select>
              </div>
              {this.validationMessage('groups')}
            </div>
          </div>
          <div className='form-group'>
            <label className='col-md-4 control-label' />
            <div className='col-md-4'>
              <Button onClick={() => this.props.history.push('/users')} variant={'default'}>
                Cancel
              </Button>
              <Button variant='primary' onClick={this.handleCreateUser} disabled={!this.validForm()}>
                Add User
              </Button>
            </div>
          </div>
        </fieldset>
      </form>
    )
  }
}

export default AddUserComponent
